import { lazy } from 'react';

const FoodHygieneCertificateRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "FoodHygieneCertificate" */ '../components/steps/food-hygiene-certificate-step/FoodHygieneCertificate'
    ),
);

export default FoodHygieneCertificateRoute;
